import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../ui/button";
import { useAtom } from "jotai";
import { chartDateRangeAtom, locale } from "@/store/global";
import { addDays, addMonths, addWeeks, endOfDay, format, startOfDay } from "date-fns";

export const ExpenseChartSelectionDate = () => {
  const [chartDateRange, setChartDateRange] = useAtom(chartDateRangeAtom);

  // Formatting dates for display
  const formattedFirstDate = format(startOfDay(new Date(chartDateRange.startDate)), "d MMM", { locale });
  const formattedLastDate = format(endOfDay(new Date(chartDateRange.endDate)), "d MMM", { locale });

  const dateRange = `${formattedFirstDate} - ${formattedLastDate}`;

  // Checking if the next week is beyond today
  const isNextDisabled = addDays(endOfDay(chartDateRange.endDate), 1) >= startOfDay(addMonths(new Date(), 1));

  function handleChangeDateRange(action: "prev" | "next") {
    if (action === "prev") {
      setChartDateRange({
        startDate: startOfDay(addWeeks(chartDateRange.startDate, -1)),
        endDate: endOfDay(addWeeks(chartDateRange.endDate, -1)),
      });
    } else {
      setChartDateRange({
        startDate: startOfDay(addWeeks(chartDateRange.startDate, 1)),
        endDate: endOfDay(addWeeks(chartDateRange.endDate, 1)),
      });
    }
  }

  return (
    <div className="flex w-full items-center justify-center space-x-1 px-5 pt-2">
      <Button
        onClick={() => handleChangeDateRange("prev")}
        data-attr="expense-chart-selection-date-previous-button"
        title="Previous week"
        size="xs"
        variant="outline"
      >
        <ChevronLeft size={16} />
      </Button>
      <span className="rounded-md bg-neutral-50 px-2 py-1 text-sm font-semibold text-neutral-700">{dateRange}</span>
      <Button
        disabled={isNextDisabled}
        onClick={() => handleChangeDateRange("next")}
        data-attr="expense-chart-selection-date-next-button"
        title="Next week"
        size="xs"
        variant="outline"
      >
        <ChevronRight size={16} />
      </Button>
    </div>
  );
};
